import React from 'react'
import arrowRight from "../../../assets/arrow-right.svg"

type BackButtontype = {
    onBack: () => void
}

function BackButton(props:BackButtontype) {
    return (
        <button
            onClick={props.onBack}
            className='flex items-center py-3 px-8 rounded-full w-fit gap-4 transition-all ease-in duration-300 group border border-secondary hover:bg-base-100 hover:border hover:border-secondary'>
            <img
                src={arrowRight}
                alt="Pfeil Rechts"
                className="group-hover:-translate-x-1 transition-all ease-in duration-200 rotate-180"
            />
        </button>
    )
}

export default BackButton